import { z } from 'zod';

import { VALIDATE } from '@/shared/constants/validation';

export const crazyMenuItem = z.object({
  name: VALIDATE.REQUIRED,
  price: z.coerce.number().min(1, { message: 'Field is required' })
});
export const consummationItem = z.object({
  name: VALIDATE.REQUIRED,
  price: z.coerce.number().min(1, { message: 'Field is required' }),
  reward: z.number().min(1, { message: 'ПField is required' })
});

export const paymentsFormSchema = z.object({
  data: z.object({
    crazyMenu: z.array(crazyMenuItem),
    consummationItems: z.array(consummationItem)
  }),
  additional: z.object({})
});
